import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const serviceCategoryApiKeyStore = {
  createServiceCategory: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_SERVICE_CATEGORY`],
    route: `/Service/Category`,
    action: 'POST',
  }),
  updateServiceCategory: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_SERVICE_CATEGORY`],
    route: `/Service/Category`,
    action: 'PUT',
  }),
  deleteServiceCategory: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_SERVICE_CATEGORY`, id],
    route: `/Service/Category/${id}`,
    action: 'DELETE',
  }),
  getServiceCategories: (): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_CATEGORIES`],
    route: `/Service/Category`,
  }),
};
